import { render, staticRenderFns } from "./DailyChallenge.vue?vue&type=template&id=88137452&scoped=true"
import script from "./DailyChallenge.vue?vue&type=script&lang=js"
export * from "./DailyChallenge.vue?vue&type=script&lang=js"
import style0 from "./DailyChallenge.vue?vue&type=style&index=0&id=88137452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88137452",
  null
  
)

export default component.exports